enum ReOpenClosedRequestPermissions {
    RE_OPEN_CLOSED_REQUEST = "Re-Open Closed Request"
  }
  
  export default ReOpenClosedRequestPermissions;
  